<template>
  <div class="course">
    <Headers></Headers>
    <div class="video">
      <div class="top clear">
        <div class="vleft">
          <div class="prism-player" id="J_prismPlayer">
            <p class="subtitle">{{subtitle}}</p>
          </div>
        </div>
        <div class="vright">
          <div>教学设施与相关资源</div>
          <div @click="changeView('pptLocation')" :class="{changeView:playVideo.pptLocation==null}">课程讲义与PPT</div>
          <div @click="changeView('homeWorkLocation')" :class="{changeView:playVideo.homeWorkLocation==null}">课程作业与思考题</div>
          <div @click="changeView('guideBookLocation')" :class="{changeView:playVideo.guideBookLocation==null}">实验指导书</div>
          <div @click="changeView('answerLocation')" :class="{changeView:playVideo.answerLocation==null}">实验答案</div>
          <div @click="changeView('sekLocation')" :class="{changeView:playVideo.sekLocation==null}">7nm微纳电子器件教学套件</div>
          <div @click="changeView('psekLocation')" :class="{changeView:playVideo.psekLocation==null}">14nm集成电路工艺教学套件</div>
          <div @click="changeView('vsekLocation')" :class="{changeView:playVideo.vrLocation==null}">7nm集成电路虚拟现实（VR实验室）</div>
          <div @click="changeView('edaLocation')" :class="{changeView:playVideo.edaLocation==null}">EDA云平台与仿真环境</div>
          <div @click="changeView('reference')" :class="{changeView:playVideo.reference==null}">参考资料</div>
          <div @click="changeView('examFinished')" :class="{changeView:playVideo.examFinished==null}">考核</div>
          <div @click="changeView('prober')" v-if="isVR">VR线上云平台</div>
          <!--不用去掉注释20220308byfgq-->
          <!-- <router-link :to='{name: "test", params: { id: this.playVideo.vid+"0000" }}' target="_blank" style="color:#fff" v-if="isLogin&&!playVideo.examFinished">考核</router-link>
          <div v-if="!isLogin&&!playVideo.examFinished" @click="message">考核</div>
          <div @click="changeView('test')" v-if="playVideo.examFinished" class="changeView">您已通过考核</div> -->
        </div>
      </div>
      <div class="bottom">
        <div class="name">{{data.cname?data.cname:"暂无信息"}}</div>
        <div class="time">
          <span>
            <img src="/static/images/play.png" />
            {{data.videos?data.videos.length:0}}课时&nbsp;&nbsp;&nbsp;{{data.time}}
          </span>
          <span>
            <img src="/static/images/study.png" />
            {{data.clickRate}}人已学习
          </span>
          <span>
            <img src="/static/images/keyword.png" />
            关键字：
            <span>{{data.keyword?data.keyword:"暂无"}}</span>
          </span>
        </div>
        <!-- <p class="background">课程简介：{{data.courseBackground?data.courseBackground:'暂无简介'}}</p> -->
      </div>
    </div>
    <div class="videos">
      <div class="title">
        <img src="/static/images/navicon.png" />课程目录
      </div>
      <div class="relate" v-for="(item,index) in data.videos" :key="index">
        <div class="bodyList">
          <div class="body" @click="play(item,index)" v-if="item.vid!=playVideo.vid">
            <div class="name">{{item.videoName}}</div>
            <!-- <div class="info">
              简介：{{item.videoDescription}}
            </div> -->
          </div>
          <div class="body bodys" v-if="item.vid==playVideo.vid">
            <div class="name">
              {{item.videoName}}
            </div>
            <!-- <div class="info">
              简介：{{item.videoDescription}}
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <Confirm :info="confirmInfo" @closeConfirm="confirmDisplay=false" v-if="confirmDisplay"></Confirm>
  </div>
</template>

<script>
/* eslint-disable */
import {
  QualityComponent,
  RateComponent,
  getCourse,
  checkVideo,
  addVideoDuration,
  getUserEDA
} from "@/assets/js/axios.js";
import Confirm from "@/modules/confirm.vue";
import Headers from "@/modules/headers.vue";
export default {
  name: "course",
  data() {
    return {
      player: "",
      sub: [],
      index: -1,
      subtitle: "",
      commentIndex: -1,

      confirmDisplay: false,
      confirmInfo: {
        title: "提示",
        des: "对不起还没有相关信息"
      },
      data: {},
      playVideo: {},
      maxCurrentTime:0,
      isLogin:this.cookieVue.getCookie("loginStatus"),
      timer:null,
      userEDA:"该课程需要使用EDA云平台，请联系客服索取",
      isVR:false,
      vrCid:[
          {id:87304,url:"/prober/"},
          {id:87328,url:"/w0gddnnp/"},
          {id:87362,url:"/vudrm8wiEuv/"}, 
          {id:87366,url:"https://app.3dcat.live/share-app?appKey=10ydocvL2KdtWj8j"}//测试网站加VR课程20220311byfgq
      ]
    };
  },
  created() {
      
    getCourse(this.$route.params.id.split('c')[0])
      .then( data  => {
        if (parseInt(data.code) === 1) {
          this.data = data.data ? data.data : {};
          
          for(let i=0;i<this.data.videos.length;i++){
            if(this.data.videos[i].vid==this.$route.params.id.split('c')[1]){
              this.playVideo = this.data.videos[i];
            }
            if(this.data.videos[i].videoName){
              this.data.videos[i].videoName=this.data.videos[i].videoName.replace(/\【([\s\S]*)\】/g,'')
            }
          }
          if(!this.playVideo.vid){
            this.playVideo = this.data.videos[0];
          }
          for(let i=0;i<this.vrCid.length;i++){
            if(this.vrCid[i].id==this.playVideo.vid){
                this.isVR=i+1;
            }
          }
          this._videoPlay()
        }
      });
    getUserEDA().then(res=>{
      if(res.code==1 && res.data){
        this.userEDA="<a href='"+res.data.downloadUrl
        +"' target='_blank' style='color:#109eff'>VNC下载地址(点击查看)</a><br/>提取码："+res.data.downloadPassword
        +"<br/>VNC登录地址："+res.data.host
        +"<br/>密码："+res.data.password
      }
    });
  },
  components: {
    Confirm,
    Headers
  },
  beforeDestroy(){
     this.clearTimer()
  },
  methods: {
    clearTimer(){
      if(this.timer)
      {
          clearTimeout(this.timer);
          this.timer = null;
      }
    },
    _addVideoDuration(){
    // ICRD学习期间需要放开注释，启动功能，记录学习时间长度20220307byfgq
    //  let currentTime=this.player.getCurrentTime()>this.maxCurrentTime?this.player.getCurrentTime():this.maxCurrentTime
    //  currentTime=parseInt(currentTime*1000)
    //  addVideoDuration(currentTime,this.playVideo.vid)
    //  .then(data => {
    //       if(data.code==-1&&data.before!=-1){
    //         this.player.pause()
    //         this.$alert('您处于离线状态，如需继续观看请重新登录','提示：',{
    //           confirmButtonText: '确认',
    //           callback: action => {
    //             this.$router.go(0)
    //           }
    //         })
    //       }
    //  })
    // ICRD学习期间需要放开注释，启动功能，记录学习时间长度20220307byfgq  
    },
    changeView(key) {
      //是否存在
      if(this.playVideo[key]==null && key!="prober"){
        this.confirmInfo={
          title: "提示",
          des: "该课程暂无此内容"
        }
        this.confirmDisplay = true;
      }else{
        //是否登录
        if(this.isLogin){
          //是否有权限
          if(this.data.isBuy){
            if(key=="reference"){
              this.confirmInfo={
                title: "提示",
                des: "该课程包含如下参考资料",
                data:this.playVideo.reference
              }
              this.confirmDisplay = true
            }else if(key=="prober"){
                window.open(this.vrCid[this.isVR-1].url, '_blank');
            }else if(key=="examFinished"){
              if(this.playVideo.examFinished){
                this.confirmInfo={
                  title: "提示",
                  des: "您已完成考核",
                }
                this.confirmDisplay=true
              }else{
                let routeUrl = this.$router.resolve({
                  name: "test",
                  params: {id:this.playVideo.vid+"0000"}
                });
                window.open(routeUrl.href, '_blank');
              }
            }else if(key=="edaLocation"){
              this.confirmInfo={
                title: "提示",
                des: this.userEDA,
                status:true
              }
              this.confirmDisplay = true;
            }else if(key=="sekLocation"){
              key = key.replace(/Location/,"")
              this.confirmInfo={
                title: "提示",
                des: "该课程需要7nm微纳电子器件教学套件（"+key.toUpperCase()+"）,请联系客服索取",
                status:true,
                more:true,
                morekey:key.toUpperCase()
              }
              this.confirmDisplay = true;
            }else if(key=="psekLocation"){
              key = key.replace(/Location/,"")
              this.confirmInfo={
                title: "提示",
                des: "该课程需要14nm集成电路工艺教学套件（"+key.toUpperCase()+"）,请联系客服索取",
                status:true,
                more:true,
                morekey:key.toUpperCase()
              }
              this.confirmDisplay = true;
            }else if(key=="vsekLocation"){
              key = key.replace(/Location/,"")
              this.confirmInfo={
                title: "提示",
                des: "该课程需要7nm集成电路虚拟现实（VR实验室）（"+key.toUpperCase()+"）,请联系客服索取",
                status:true,
                more:true,
                morekey:key.toUpperCase()
              }
              this.confirmDisplay = true;
            }else{
              window.open(this.playVideo[key], '_blank');
            }
          }else{
            this.confirmInfo={
              title: "提示",
              des: "对不起，您还未购买该课程，请联系客服购买",
              status:true
            }
            this.confirmDisplay = true;
          }
        }else{
          this.confirmInfo={
            title: "提示",
            des: "请先登录"
          }
          this.confirmDisplay = true;
        }
      }
    },
    toSeconds(t) {
      var s = 0.0;
      if (t) {
        var p = t.split(":");
        for (let i = 0; i < p.length; i++) {
          s = s * 60 + parseFloat(p[i].replace(",", "."));
        }
      }
      return s;
    },
    handle() {
      let time = this.player.getCurrentTime();
      let i = this.index;
      if (time < this.sub[i].endTime && time > this.sub[i].startTime) {
        this.subtitle = this.sub[i].content;
      } else if (time > this.sub[i].endTime || time < this.sub[i].startTime) {
        this.subtitle = "";
        for (let i = 0; i < this.sub.length; i++) {
          if (time < this.sub[i].endTime && time > this.sub[i].startTime) {
            this.index = i;
            this.subtitle = this.sub[i].content;
            break;
          }
        }
      }
    },
    play(item,index) {
      if(this.isLogin){
        this._addVideoDuration()
      }
      this.playVideo = item;
      this.clearTimer()
      this.$router.push({
        name: "course",
        params: { id: this.data.cid+'c'+item.vid }
      });
      this._videoPlay()
    },
    _videoPlay() {
      checkVideo(this.playVideo.videoLocation,this.playVideo.vid)
        .then(({data}) => {
          if (this.player) {
            this.player.dispose();
          }
          this.maxCurrentTime=data.viewDuration/1000;
          let that = this;
          this.player = new Aliplayer(
            {
              id: "J_prismPlayer",
              height: "100%",
              width: "100%",
              vid: data.videoid,
              cover: data.coverurl,
              playauth: data.playAuth,
              encryptType: 1,
              isLive: false,
              defaultDefinition: "OD",
              components: [
                {
                  name: "QualityComponent",
                  type: QualityComponent
                },
              ],
            },
            function() {
              if(!that.isLogin){
                return
              }
              that.player.seek(that.maxCurrentTime);
              //拖拽
              var currentTime=0;
              var count=0;
              function getTime()
              { 
                var newCurrentTime = that.player.getCurrentTime();
                //to do
                if(newCurrentTime-1.5<currentTime||currentTime==0){
                  currentTime=newCurrentTime;
                }
                that.timer = setTimeout(getTime,1000);
                count++
                if(count==10){
                  count=0
                  that._addVideoDuration()
                }
              }
              //清除定时器
              function clear()
              {
                if(that.timer)
                {
                    clearTimeout(that.timer);
                    that.timer = null;
                }
              }
              that.player.on('ended',function  (e) {
                clear();
              });
              that.player.on('pause',function  (e) {
                clear();
              });
              that.player.on('error',function  (e) {
                clear();
              });
              that.player.on("play",function (e) {
                count=0
                getTime();
              })
              that.player.on('completeSeek',function (e) {
                if(e.paramData>currentTime&&e.paramData>that.maxCurrentTime){
                  setTimeout(function(){
                    that.player.seek(currentTime>that.maxCurrentTime?currentTime:that.maxCurrentTime);
                    that.$message({
                        message: '由于视频有考核要求，不能拖动到未学习区域',
                        type: 'warning'
                    });
                  },0)
                }else{
                  that.maxCurrentTime=currentTime>that.maxCurrentTime?currentTime:that.maxCurrentTime;
                }
              })
              that.player.on('ended',function (e) {
                clear()
                that._addVideoDuration()
              });
            }
          );
        });
    }
  }
};
/* eslint-disable */
</script>

<style lang="less" scoped>
.course {
  background: #f8f8f8;
  .video {
    min-width: 1200px;
    overflow: hidden;
    background: #fff;
    box-shadow: 1px 1px 3px rgb(224, 224, 224), -1px -1px 3px rgb(224, 224, 224);
    position: relative;
    .top {
      background: #252525;
      height: 673px;
      padding-left: calc(50vw - 600px);
      width: 100vw;
      box-sizing: border-box;
      min-width: 1200px;
      .vleft {
        float: left;
        width: calc(50vw + 230px);
        height: 673px;
        .prism-player {
          width: 100%;
          max-width: 1200px;
          max-height: 673px;
          display: block;
          /deep/ .prism-controlbar .prism-controlbar-bg {
            background: rgba(75, 75, 75, 0.55);
          }
          /deep/ .prism-cc-btn,
          /deep/ .prism-setting-btn {
            display: none;
          }
          /deep/ .prism-volume {
            left: -19px;
            margin-left: 30px;
          }
          /deep/ .player-hidden {
            display: none !important;
          }

          /deep/ .quality-components {
            float: right;
            color: #fff;
            position: relative;
            box-sizing: border-box;
            top: 14px;
          }

          /deep/ .current-quality {
            display: flex;
            height: 100%;
            align-items: center;
            justify-content: center;
            width: 70px;
            cursor: pointer;
          }

          /deep/ .quality-list {
            position: absolute;
            bottom: 46px;
            display: none;
            padding: 0;
            margin: 0;
            list-style: none;
            li {
              text-align: center;
              width: 70px;
              line-height: 30px;
              background-color: rgba(0, 0, 0, 0.6);
              cursor: pointer;
              &.current {
                color: #00c1de;
              }
              & + li {
                border-top: 1px solid rgba(78, 78, 78, 0.3);
              }
              &:hover {
                background-color: rgba(0, 0, 0, 0.5);
              }
            }
          }

          /deep/ .quality-modal {
            position: absolute;
            bottom: 20%;
            left: 5%;
            background-color: rgba(0, 0, 0, 0.6);
            border-radius: 5px;
            color: #fff;
            padding: 10px 15px;
            font-size: 14px;
            display: none;
            span {
              color: #00c1de;
            }
          }
          /deep/ .rate-components {
            float: right;
            color: #fff;
            position: relative;
            box-sizing: border-box;
            top: 14px;
            .translate {
              line-height: 40px;
              cursor: pointer;
            }
          }

          /deep/ .cc-components {
            float: right;
            color: #fff;
            position: relative;
            box-sizing: border-box;
            top: 14px;
            .translate {
              display: flex;
              height: 100%;
              align-items: center;
              justify-content: center;
              width: 70px;
              cursor: pointer;
            }
          }

          /deep/ .current-rate {
            display: flex;
            height: 100%;
            align-items: center;
            justify-content: center;
            width: 70px;
            cursor: pointer;
          }

          /deep/ .rate-list {
            position: absolute;
            bottom: 46px;
            display: none;
            padding: 0;
            margin: 0;
            list-style: none;
            li {
              text-align: center;
              width: 70px;
              line-height: 30px;
              background-color: rgba(0, 0, 0, 0.6);
              cursor: pointer;
              &.current {
                color: #00c1de;
              }
              & + li {
                border-top: 1px solid rgba(78, 78, 78, 0.3);
              }
              &:hover {
                background-color: rgba(0, 0, 0, 0.5);
              }
            }
          }
        }
      }
      .vright {
        float: left;
        width: 330px;
        color: #fff;
        margin: 18px 16px 0;
        height: 643px;
        color: #fff;
        font-size: 16px;
        div,a{
          display: block;
          line-height: 52px;
          border-bottom: 1px solid #2b2d2d;
          padding-left: 20px;
          position: relative;
          cursor: pointer;
          &:first-child {
            font-size: 18px;
            cursor: default;
            &::before {
              display: block;
              content: "";
              position: absolute;
              width: 2px;
              height: 16px;
              background: #fff;
              left: 8px;
              top: 16px;
            }
            &:after {
              display: none;
            }
          }
          &::after {
            display: block;
            content: "";
            position: absolute;
            width: 10px;
            height: 10px;
            border: 2px solid #fff;
            transform: rotate(45deg);
            border-color: #fff #fff transparent transparent;
            right: 4px;
            top: 19px;
          }
        }
        .changeView {
          color: #666;
          &::after {
            border-color: #666 #666 transparent transparent;
          }
        }
      }
    }
    .subtitle {
      position: absolute;
      bottom: 10%;
      left: 0;
      font-size: 22px;
      letter-spacing: 1px;
      text-shadow: 1px 1px 2px #004e83, -1px -1px 2px #004e83;
      font-weight: 900;
      color: #fff;
      -webkit-text-stroke: 1px #004e83;
      font-family: Microsoft YaHei;
      width: 100%;
      text-align: center;
    }
    .bottom {
      width: 1200px;
      margin: 0 auto 20px;
      .name {
        line-height: 68px;
        font-size: 18px;
      }
      .time {
        font-size: 0;
        color: #666;
        span {
          font-size: 12px;
          display: inline-block;
          padding-right: 76px;
          img {
            padding-right: 8px;
            color: #999;
            height: 14px;
            position: relative;
            top: 2px;
          }
        }
        span:last-child {
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 790px;
          padding-right: 0;
          a {
            color: #666;
          }
          a:hover {
            color: #109eff;
          }
        }
      }
      .background {
        line-height: 24px;
        font-size: 14px;
        margin: 14px 0;
      }
    }
  }
  .videos {
    background: #fff;
    width: 1200px;
    margin: 10px auto 50px;
    border-radius: 4px;
    padding-bottom: 50px;
    .title {
      color: #004e83;
      font-size: 18px;
      height: 35px;
      padding-left: 26px;
      padding-top: 25px;
      margin-bottom: 15px;
      border-bottom: 1px solid #e5e5e5;
      img {
        font-size: 24px;
        position: relative;
        top: 2px;
        margin-right: 10px;
      }
    }
    .list {
      display: block;
      padding-left: 26px;
      margin-top: 30px;
      .l_left {
        position: relative;
        width: 103px;
        height: 59px;
        float: left;
        border: 1px solid #f8f8f8;
        border-radius: 8px;
        box-sizing: border-box;
        img {
          width: 103px;
          height: 59px;
          cursor: pointer;
          border-radius: 8px;
          object-fit: cover;
        }
      }
      .l_right {
        float: left;
        margin-left: 20px;
        width: 1020px;
        h3 {
          cursor: pointer;
          font-size: 14px;
          color: #000;
          font-weight: normal;
          height: 24px;
          line-height: 14px;
          span {
            float: right;
            color: #666;
            img {
              position: relative;
              top: 2px;
              margin-right: 2px;
            }
          }
        }
        p {
          width: 1030px;
          color: #666;
          height: 40px;
          line-height: 20px;
          font-size: 12px;
          overflow: hidden;
        }
      }
    }
    .body {
      padding: 15px 120px 15px 28px;
      cursor: pointer;
      position: relative;
      .name {
        font-size: 14px;
        position: relative;
        padding-left:30px;
        &::before{
          position: absolute;
          display: block;
          content: "";
          top:2px;
          left: 0;
          width: 16px;
          height: 16px;
          background: #9099a1;
          border-radius: 10px;
        }
        &::after{
          position: absolute;
          display: block;
          content: "";
          border-width: 4px;
          border-style: solid;
          border-color:#fff #fff transparent transparent ;
          top:5.6px;
          left:2.4px;
          transform: rotate(45deg);
        }
        i {
          font-size: 20px;
          color: #9099a1;
          margin-right: 14px;
          position: relative;
          top: 2px;
        }
      }
      .info {
        font-size: 12px;
        color: #666;
        padding: 6px 10px 0 35px;
      }
    }
    .bodys {
      color: #004e83;
      .name {
        &::before{
          background: #004e83;
        }
        &::after{
          position: absolute;
          display: block;
          content: "";
          width: 2px;
          height: 8px;
          border: none;
          border-left:2px solid #fff;
          border-right: 2px solid #fff;
          top:6px;
          left:5px;
          transform: none;
        }
        i {
          color: #004e83;
        }
      }
      .info {
        color: #004e83;
      }
    }
    .bodyList{
      margin: 0 8px;
      border-radius: 6px;
      &:hover {
        background: #f0f9ff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course.vue